<template>
  <div>
    <a-layout-content>
      <a-breadcrumb>
        <a-breadcrumb-item>系统设置</a-breadcrumb-item>
        <a-breadcrumb-item>个人管理</a-breadcrumb-item>
        <a-breadcrumb-item>基本信息</a-breadcrumb-item>
      </a-breadcrumb>
      <a-layout class="space-20 bg_white">
        <a-layout-sider width="220" class="bg_white">
          <a-menu v-model="current" mode="inline">
            <a-menu-item key="base">
              <span>基本设置</span>
            </a-menu-item>
            <!-- <a-menu-item key="safe">
              <span>安全设置</span>
            </a-menu-item>-->
          </a-menu>
        </a-layout-sider>
        <a-layout-content class="info-content">
          <p class="title m-b-md">{{ current[0] == 'base' ? '基本设置' : '安全设置' }}</p>
          <div class="base" v-show="current[0] == 'base'">
            <div class="left">
              <a-form>
                <a-form-item label="昵称" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
                  {{ data.nickname }}
                  <!-- <a-input v-model="data.nickname"></a-input> -->
                </a-form-item>
                <!-- <a-form-item label="简介">
                  <a-textarea :rows="4" placeholder="个人简介"></a-textarea>
                </a-form-item>-->
                <a-form-item>
                  <!-- <a-textarea :rows="4" placeholder="个人简介"></a-textarea> -->
                </a-form-item>
                <!-- <a-form-item>
                  <a-button type="primary" @click="handleSubmit">更新头像</a-button>
                </a-form-item> -->
              </a-form>
            </div>
            <div class="right">
              <a-form-item label="头像">
                <img :src="data.avatar" alt />
              </a-form-item>
              <!-- <a-upload :showUploadList="false" name="avatar" :headers="headers" :action="uploadAction" :beforeUpload="beforeUpload" @change="handleChange">
                <a-button :loading="uploading"> <a-icon type="upload" />点击上传 </a-button>
              </a-upload>
              <p>(支持JPG、PNG格式图片，大小不超过1MB)</p> -->
            </div>
          </div>
          <div class="safe" v-show="current[0] == 'safe'">
            <div class="safe-item">
              <div>
                <span class="label">账户密码</span>
                <p>当前密码强度：强</p>
              </div>
              <a href="jvascript:;" @click="pwdModal = true">修改</a>
            </div>
            <div class="safe-item">
              <div>
                <span class="label">手机账号</span>
                <p>已绑定手机：{{ userInfo.phone }}</p>
              </div>
              <a href="jvascript:;" @click="phoneModal = true">修改</a>
            </div>
            <div class="safe-item">
              <div>
                <span class="label">邮箱账号</span>
                <p>已绑定邮箱：{{ userInfo.name }}</p>
              </div>
              <a href="jvascript:;" @click="emailModal = true">修改</a>
            </div>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout-content>
    <a-modal title="修改密码" width="360px" v-model="pwdModal" :footer="null">
      <a-form>
        <a-form-item label="原密码">
          <a-input v-model="safeInfo.pwd.old"></a-input>
        </a-form-item>
        <a-form-item label="新密码">
          <a-input v-model="safeInfo.pwd.new"></a-input>
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input v-model="safeInfo.pwd.new2"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button class="width_100" type="primary" @click="pwdModal = false">保存</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="修改手机" width="360px" v-model="phoneModal" :footer="null">
      <a-form>
        <a-form-item>
          <a-input v-model="safeInfo.phone.phone" placeholder="手机号">
            <a-icon slot="prefix" type="mobile" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-row>
            <a-col :span="14">
              <a-input placeholder="验证码">
                <a-icon slot="prefix" type="mail" />
              </a-input>
            </a-col>
            <a-col :span="8" :offset="2">
              <a-button>获取验证码</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item>
          <a-button class="width_100" type="primary" @click="phoneModal = false">绑定</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="修改手机" width="360px" v-model="emailModal" :footer="null">
      <a-form>
        <a-form-item>
          <a-input v-model="safeInfo.phone.phone" placeholder="邮箱">
            <a-icon slot="prefix" type="mail" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button class="width_100" type="primary" @click="emailModal = false">保存</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { editSelf } from '@/api/systemUserSetting.js';
import { getInfo } from '@/api/user.js';
import { getToken } from '@/assets/js/auth';
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      emailModal: false,
      phoneModal: false,
      pwdModal: false,
      uploading: false,
      current: ['base'],
      uploadAction: process.env.VUE_APP_BASE_API + '/upload/uploadAvatar',
      safeInfo: {
        pwd: {
          old: '',
          new: '',
          new2: ''
        },
        phone: {
          phone: '',
          code: ''
        },
        email: ''
      },
      data: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    headers() {
      return { Authorization: getToken() };
    }
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploading = true;
        return;
      }
      if (info.file.status === 'done') {
        getBase64(info.file.originFileObj, () => {
          this.data.avatar = info.file.response.data;
          this.uploading = false;
          this.$store.dispatch('user/getUserInfo');
        });
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('图片不能超过1MB!');
      }
      return isLt2M;
    },
    getUserInfo() {
      getInfo(this.userInfo.id).then(res => {
        this.data = res.data;
      });
    },
    handleSubmit() {
      const { name, nickname, phone } = this.data;
      editSelf({
        nickname,
        name,
        phone
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.$store.dispatch('user/getUserInfo');
          this.getUserInfo();
        }
      });
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
.info-content {
  margin-left: 20px;
  [upload] {
    border: 1px solid #ddd;
    padding: 4px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  .title {
    font-size: 20px;
  }
  .base {
    display: flex;
    .left {
      width: 325px;
      margin-right: 100px;
    }
    .right {
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
    }
  }
  .safe {
    width: 650px;
    .safe-item {
      font-size: 14px;
      line-height: 30px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      color: #8c8c8c;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:not(:last-child) {
        border-bottom: 1px solid #e8e8e8;
      }
      .label {
        color: #333;
        cursor: pointer;
        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>
